export default __webpack_public_path__ + "static/media/mobile1.5340cb15.png";